module.exports = __webpack_public_path__ + "media/soundtrack.db13248c.mp3";